import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'as-create-panel',
  templateUrl: './create-panel.component.html',
  styleUrls: ['./create-panel.component.scss']
})
export class CreatePanelComponent implements OnInit {

  @Input() name : string;
  @Input() into : string;
  @Input() iconclass : string;
  @Input() destination: string
  @Input() path: string
  @Input() special: string;
  @Input() link: string = null;

  constructor() { }

  ngOnInit() {
  }

  redirect(){
    window.location.href = this.link;
  }

}
